import { useLocaleField } from '@/hooks/useLocaleField';
import { Box, Flex, Text } from '@chakra-ui/react';
import { PortableText } from '@portabletext/react';
import { FC } from 'react';
import { MotionBox } from '../MotionBox';
import styles from './IntroText.module.css';
import { IntroTextProps } from './IntroText.props';

const IntroText: FC<IntroTextProps> = ({ isCentered = false, subtitle, title, description }) => {
  const { getLocaleField, getLocaleBlock } = useLocaleField();

  return (
    <Box>
      {isCentered ? (
        <Flex flexDirection="column" align="center" mt={{ sm: '50px', md: '70px' }}>
          <MotionBox
            initial={{ t: 15, opacity: 0 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5, type: 'spring' }}
          >
            <Text as="h3" fontFamily="heading" color="primary" fontSize="sm">
              {subtitle}
            </Text>
          </MotionBox>
          <MotionBox
            align="center"
            maxW="500px"
            initial={{ y: 10, opacity: 0 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 1, type: 'spring' }}
          >
            <Text mb="4" letterSpacing="-0.1rem" as="h2" fontSize={{ md: '5xl', base: '4xl' }}>
              {title}
            </Text>
          </MotionBox>
          <MotionBox
            maxW="680px"
            align="center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 1, type: 'spring' }}
            color="gray.700"
            fontSize="lg"
          >
            <PortableText value={getLocaleBlock(description)} />
          </MotionBox>
        </Flex>
      ) : (
        <Flex
          pt={{ md: '3rem', base: '2rem' }}
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
        >
          <Box flexBasis={{ md: '30%', base: '100%' }}>
            <MotionBox
              initial={{ t: 15, opacity: 0 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5, type: 'spring' }}
            >
              <Text as="h3" fontSize="sm">
                {subtitle}
              </Text>
            </MotionBox>
            <MotionBox
              initial={{ y: 10, opacity: 0 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 1, type: 'spring' }}
            >
              <Text mb="4" letterSpacing="-0.1rem" as="h2" fontFamily="heading" fontSize={{ md: '5xl', base: '4xl' }}>
                {title}
              </Text>
            </MotionBox>
          </Box>
          <Box flexBasis={{ md: '70%', base: '100%' }} px={{ base: 0, md: '2rem' }}>
            <MotionBox
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 1, type: 'spring' }}
            >
              <PortableText value={getLocaleBlock(description)} />
            </MotionBox>
          </Box>
        </Flex>
      )}
    </Box>
  );
};

export { IntroText };
